import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import i18next from 'i18next';

const ProductColumns = () => {
    return [
        {
            align: 'left',
            field: 'name',
            flex: 1,
            headerName: i18next.t('Name'),
            renderCell: (params) => {
                const { row } = params;
                return <Typography variant="caption">{row.name}</Typography>;
            },
        },
    ];
};

ProductColumns.propTypes = {};

export default ProductColumns;
